module.exports = __webpack_public_path__ + "media/tr_tr_s4_Nehir.601c0aa9.mp3";